import styled from 'styled-components';

export const ContentWrapper = styled.div`
  background-color: ${({ theme }) => theme.mocaBg};
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ScrollList = styled.div`
  overflow-y: scroll;
  flex: 1;
  padding: 15px;
  padding-bottom: 67px;
  flex-direction: column;
  scroll-behavior: smooth;
`
